import app from '@/app';
import templateUrl from './campaign-detail.html';

/* @ngInject */
function Controller($controller, Campaign, Principal, User) {
	const $ctrl = this;
	$ctrl.currentAccount = null;
	$ctrl.selectableUsers = [];

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
		applyUserFilter();
	});

	$controller('AbstractEntityDetailController', {
		$ctrl: this,
		resource: Campaign,
		type: 'campaign'
	});

	// Datepicker options
	$ctrl.headDateOptions = { minMode: 'month' };
	$ctrl.tailDateOptions = { minMode: 'month' };
	$ctrl.dateRangeInvalid = false;

	// Initialize minDate constraint when entity is available
	var originalInit = $ctrl.$onInit;
	$ctrl.$onInit = function () {
		if (originalInit) originalInit();
		applyUserFilter();
		if ($ctrl.entity && $ctrl.entity.headDate) {
			$ctrl.tailDateOptions = Object.assign({}, $ctrl.tailDateOptions, { minDate: $ctrl.entity.headDate });
		}
	};

	// Hides the current user, system users and administrators: both already have
	// access to every record, so they are never authorized individually
	function applyUserFilter() {
		if (!$ctrl.currentAccount || !$ctrl.allUsers || !$ctrl.allUsers.content) {
			return;
		}
		$ctrl.selectableUsers = $ctrl.allUsers.content.filter(user => {
			if (user.login === $ctrl.currentAccount.login) return false;
			if (isSystem(user)) return false;
			return !isAdmin(user);
		});
	}

	function isSystem(user) {
		return (user.authorities || []).indexOf('SYSTEM') !== -1;
	}

	function isAdmin(user) {
		return (user.authorities || []).indexOf('USERS_WRITE') !== -1;
	}

	// Access management (authorizing users) is restricted to System and
	// Administrator users only. Not even the campaign creator may manage it.
	$ctrl.canManageAccess = function () {
		if (!$ctrl.currentAccount) return false;
		return isSystem($ctrl.currentAccount) || isAdmin($ctrl.currentAccount);
	};

	// Update tailDate minDate when headDate changes
	$ctrl.onHeadDateChange = function () {
		$ctrl.tailDateOptions = Object.assign({}, $ctrl.tailDateOptions, { minDate: $ctrl.entity.headDate });
		$ctrl.validateDateRange();
	};

	// Validate when tailDate changes
	$ctrl.onTailDateChange = function () {
		$ctrl.validateDateRange();
	};

	// Check that tailDate >= headDate
	$ctrl.validateDateRange = function () {
		if ($ctrl.entity && $ctrl.entity.headDate && $ctrl.entity.tailDate) {
			$ctrl.dateRangeInvalid = new Date($ctrl.entity.tailDate) < new Date($ctrl.entity.headDate);
		} else {
			$ctrl.dateRangeInvalid = false;
		}
	};

	// Checks if the user is in the list of authorized users
	$ctrl.isAuthorized = function(user) {
		return (
			$ctrl.entity.authorizedUsers &&
			$ctrl.entity.authorizedUsers.some(function(u) {
				return u.id === user.id;
			})
		);
	};

	// Adds or removes the user from the list of authorized users
	$ctrl.toggleUser = function(user) {
		if (this.campaignForm) {
			this.campaignForm.$setDirty();
		}
		if (!$ctrl.entity.authorizedUsers) {
			$ctrl.entity.authorizedUsers = [];
		}

		const index = $ctrl.entity.authorizedUsers.findIndex(function(u) {
			return u.id === user.id;
		});

		if (index > -1) {
			// User is already in the list → remove it
			$ctrl.entity.authorizedUsers.splice(index, 1);
			return;
		}
		// User is not in the list → add it
		$ctrl.entity.authorizedUsers.push(user);
	};
}

const component = {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^campaignSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<',
		allUsers: '<'
	}
};

app.component('campaignDetail', component);
